export default __webpack_public_path__ + "static/latest-4-fb774f0108ac2226e405a752d971ccf6.webp";